var resources = require('items-view-strings');
    var strings = resources['_GYGAlrlawOfgzt1e8qCLPQ'];
export { strings };
export default strings;
